export default __webpack_public_path__ + "static/media/sub_notification.d8f1e781.mp3";